import { render } from "./PicOfTheDay.vue?vue&type=template&id=6d35df94&scoped=true"
import script from "./PicOfTheDay.vue?vue&type=script&lang=js"
export * from "./PicOfTheDay.vue?vue&type=script&lang=js"

import "./PicOfTheDay.vue?vue&type=style&index=0&id=6d35df94&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d35df94"]])

export default __exports__